import DartDialog from '@/components/dart-dialog.vue';
import DragImgCom from '@/components/darg-img.vue';
export default {
  props: {
    files: {
      type: Array,
      default: function () {
        return [];
      }
    },
    file: {
      type: Object,
      default: {}
    },
    index: {
      type: Number,
      default: 0
    },
    showDel: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DartDialog,
    DragImgCom
  },
  data() {
    return {
      visible: false,
      leftDis: false,
      rightDis: false,
      nowIndex: 0,
      imgUrl: '',
      pdfUrl: '',
      list: [],
      filterList: [],
      imgsrc: {
        /*
          *imgsrc 是关于内部静态图片的显示的路径，需要自己设置
          *示例'xls': require('@/assets/images/file-icon/xls.png'),
          xis的文件所需要加载的路径是；assets文件下的image文件夹下的xls.png
        */
        'rar': require('@/assets/images/file-icon/zip.png'),
        'zip': require('@/assets/images/file-icon/zip.png'),
        'pdf': require('@/assets/images/file-icon/pdf.png'),
        'jpg': require('@/assets/images/file-icon/png.png'),
        'jpeg': require('@/assets/images/file-icon/png.png'),
        'png': require('@/assets/images/file-icon/png.png'),
        'doc': require('@/assets/images/file-icon/doc.png'),
        'docx': require('@/assets/images/file-icon/doc.png'),
        'txt': require('@/assets/images/file-icon/txt.png'),
        'xls': require('@/assets/images/file-icon/xls.png')
      }
    };
  },
  filters: {
    toKB(val) {
      return (Number(val) / 1024).toFixed(0);
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.func();
      }
    },
    nowIndex(val) { // 控制左右切换图片
      if (val === 0) {
        this.leftDis = true;
        this.rightDis = false;
      } else if (val === this.filterList.length - 1) {
        this.rightDis = true;
        this.leftDis = false;
      } else {
        this.rightDis = false;
        this.leftDis = false;
      }
    }
  },
  methods: {
    /*
      *获取到当前的files,
      *赋值给一个新数组，给每个item,定义一个临时的id(等于index)
      *过滤出所有的图片files
      *获取到当前的预览的图片的index（根据临时的id）
      *index === 0,左边禁止，index最大时右边禁止；
     */
    func() {
      this.filterList = [];
      const arr = ['png', 'jpg', 'jpeg'];
      this.list = JSON.parse(JSON.stringify(this.files));
      this.list.forEach((item, index) => {
        item.id = index;
        if (arr.includes(item.fileName && item.fileName.substring(item.fileName.lastIndexOf('.') + 1))) {// 过滤掉不符合条件的
          this.filterList.push(item);
        } else if (arr.includes(item.ossImgUrl && item.ossImgUrl.substring(item.ossImgUrl.lastIndexOf('.') + 1))) {
          this.filterList.push(item);
        }
      });
      // console.log(99999, this.filterList, this.index);
      this.filterList.forEach((item, index) => {
        if (item.id === this.index) {
          this.nowIndex = index;
          if (this.nowIndex === 0) {
            this.leftDis = true;
          } else if (this.nowIndex === this.filterList.length - 1) {
            this.rightDis = true;
          }
        }
      });
      if (this.filterList.length <= 1) {
        this.rightDis = true;
        this.leftDis = true;
      }
    },
    // 往左预览
    leftView() {
      if (this.nowIndex === 0) {
        return;
      }
      this.nowIndex -= 1;
      this.imgUrl = this.filterList[this.nowIndex] && this.filterList[this.nowIndex].ossImgUrl;
      this.$refs.dragImgEl.rotateReset(this.nowIndex);
    },
    // 往右预览
    rightView() {
      if (this.nowIndex === this.filterList.length - 1) {
        return;
      }
      this.nowIndex += 1;
      this.imgUrl = this.filterList[this.nowIndex] && this.filterList[this.nowIndex].ossImgUrl;
      this.$refs.dragImgEl.rotateReset(this.nowIndex);
    },

    // 放大
    magnify() {
      this.$refs.dragImgEl.magnify();
    },
    // 缩小
    shrink() {
      this.$refs.dragImgEl.shrink();
    },
    // 左旋转
    left(index) {
      this.$refs.dragImgEl.leftRotate(index);
    },
    // 右旋转
    right(index) {
      this.$refs.dragImgEl.rightRotate(index);
    },
    openDartDialog() {
      this.visible = true;
      // this.stop();
    },
    closeDartDialog() {
      this.visible = false;
      this.move();
    },
    // 预览大图
    preview() {
      // console.log(ossImgUrl);
      this.previewList = [];
      this.src = '';
    },
    delete() {
      this.$emit('delete', this.index);
    },
    getEnd(data) {
      // console.log(data.split('.')[1]);
      return data && data.split('.') && data.split('.')[1];
    },
    isPdf() { return true; },
    isImg() { return true; },
    cancelHanlder(index) {
      this.$emit('cancel', index);
    },
    previewHandler(data) {
      console.log(data);
      if (data) {
        const addTypeArray = data.ossImgUrl.split('.');
        const addType = addTypeArray[addTypeArray.length - 1];
        if (addType === 'pdf') {
          window.open(data.ossImgUrl, '_blank');
        } else if (addType === 'doc') {
          window.open(
            `https://view.officeapps.live.com/op/view.aspx?src=${data.ossImgUrl}`
          );
        } else if (addType === 'txt') {
          window.open(`${data.ossImgUrl}`);
        } else if (['png', 'jpg', 'jpeg'].includes(addType)) { // 图片类型
          this.visible = true;
          this.imgUrl = data.ossImgUrl;
          this.stop();
        }
      }
    }
  }
};
